import { destandard } from '../utils/commonFunctions';

export const GET_ADMIN_GAME_PENDING = 'GET_ADMIN_GAME_PENDING';
export const GET_ADMIN_GAME_FULFILLED = 'GET_ADMIN_GAME_FULFILLED';
export const GET_ADMIN_GAME_REJECTED = 'GET_ADMIN_GAME_REJECTED';
export const GET_ADMIN_GAMES_PENDING = 'GET_ADMIN_GAMES_PENDING';
export const GET_ADMIN_GAMES_FULFILLED = 'GET_ADMIN_GAMES_FULFILLED';
export const GET_ADMIN_GAMES_REJECTED = 'GET_ADMIN_GAMES_REJECTED';
export const ADD_ADMIN_GAME_PENDING = 'ADD_ADMIN_GAME_PENDING';
export const ADD_ADMIN_GAME_FULFILLED = 'ADD_ADMIN_GAME_FULFILLED';
export const ADD_ADMIN_GAME_REJECTED = 'ADD_ADMIN_GAME_REJECTED';
export const UPDATE_ADMIN_GAME_PENDING = 'UPDATE_ADMIN_GAME_PENDING';
export const UPDATE_ADMIN_GAME_FULFILLED = 'UPDATE_ADMIN_GAME_FULFILLED';
export const UPDATE_ADMIN_GAME_REJECTED = 'UPDATE_ADMIN_GAME_REJECTED';
export const GET_ADMIN_GAME_META_PENDING = "GET_ADMIN_GAME_META_PENDING";
export const GET_ADMIN_GAME_META_FULFILLED = "GET_ADMIN_GAME_META_FULFILLED";
export const GET_ADMIN_GAME_META_REJECTED = "GET_ADMIN_GAME_META_REJECTED";
export const GET_GAME_BACKGROUND_URL_PENDING = 'GET_GAME_BACKGROUND_URL_PENDING';
export const GET_GAME_BACKGROUND_URL_FULFILLED = 'GET_GAME_BACKGROUND_URL_FULFILLED';
export const GET_GAME_BACKGROUND_URL_REJECTED = 'GET_GAME_BACKGROUND_URL_REJECTED';

export default function gamesReducer(state = {
	fetching: false,
	fetched: false,
	gameBackgroundUrl: '',
	game: {},
  meta: {},
	games: []
}, action) {
	switch (action.type) {
		case GET_ADMIN_GAME_PENDING:
    case GET_ADMIN_GAME_META_PENDING:
		case GET_ADMIN_GAMES_PENDING: {
			return {
				...state,
				fetching: true,
				fetched: false  
			};
		}
		case GET_ADMIN_GAME_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				game:  destandard(action.payload.data),
        meta: action.payload.meta
			};
		}
		case GET_ADMIN_GAMES_FULFILLED: {
			return {
				...state,
				feching: false,
				fetched: true,
				games: action.payload.data
			};
		}
    case GET_ADMIN_GAME_META_FULFILLED: {
      return {
        ...state,
        feching: false,
        fetched: true,
        meta: action.payload.meta
      };
    }
		case GET_ADMIN_GAME_REJECTED: {
			return {
				...state,
				fetching: false,
				fetched: false,
				game: {}
			};
		}
    case GET_ADMIN_GAME_META_REJECTED: {
			return {
				...state,
				fetching: false,
				fetched: false,
				meta: {}
			};
		}
		case GET_ADMIN_GAMES_REJECTED: {
			return {
				...state,
				fetching: false,
				fetched: false,
				games: []
			};
		}
    case GET_GAME_BACKGROUND_URL_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_GAME_BACKGROUND_URL_FULFILLED: {
      return {
        fetching: false,
        fetched: true,
        gameBackgroundUrl: action.payload.data.game_background || ''
      };
    }
    case GET_GAME_BACKGROUND_URL_REJECTED: {
      return {
        fetching: false,
        fetched: false
      };
    }
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/gamesReducer.js